<template>
  <div class="messages-subscriptions">
    <div class="messages-subscriptions__content">
      <message :message="item" :serial="idx + 1" v-for="(item, idx) in messages" :key="item.id"></message>
    </div>
  </div>
</template>

<script>
  import Message from './Message'

  export default {
    components: {
      Message
    },

    computed: {
      messages() {
        return this.$store.getters.trashMessages;
      }
    },

    mounted() {
      this.runBlockerAction(async () => {
        try {
          await this.$store.dispatch('fetchTrash');
        }
        catch(e) {
          console.error('unable to fetch list of messages from inbox', e);
          this.globalErrorHandler(e);
        }
      })
    }
  }
</script>

<style scoped>
</style>
